<template>
  <div class="area-selection">
    <custom-todo
      v-model="localSelected"
      is-drop-down
      is-drop-down-auto-select
      icon="fa-file-alt"
      :is-read-only="isReadOnly"
      label="Diagnóstico del Estudiante:"
      :options="availableDiagnosticsOptions"
      :separator="isReadOnly ? '' : 'Diagnósticos añadidos'"
      has-chip
      has-other
      has-drag-handle
      has-pagination
      :search-settings="otherSettings"
    />
    <div class="row mt-3 mr-1 d-flex justify-content-end">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="danger mr-2"
        @click="onCancel"
      />
      <action-button
        id="btnAdd"
        i="fas fa-save"
        text="Guardar"
        variant="success"
        @click="onSave"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import ResultNotFound from 'custom-result-not-found';
import { getCodeStudentDiagnostics } from '@/modules/common/code.api.js';
import CustomTodo from '@/components/common/CustomTodo.vue';
import {
  saveStudentDiagnosis,
  getLastDiagnosis,
  searchDiagnosticsExcludingStudent,
} from '@/modules/referral/api.js';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'AddDiagnosis',
  mixins: [alert],
  components: {
    CustomDropDown,
    ActionButton,
    ResultNotFound,
    CustomTodo,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    diagnostic: null,
    diagnostics: [],
    localSelected: [],
  }),
  computed: {
    otherSettings() {
      return {
        option: Object.freeze({ id: -1, name: 'Otro' }),
        placeholder: 'Buscar diagnóstico...',
        term: null,
        termLength: 5,
        selected: null,
        data: [],
        debounceTime: 2000,
        resultMap: (v) => v.name,
        displayProp: 'name',
        handler: this.searchDiagnostics,
      };
    },
    availableDiagnosticsOptions() {
      return this.diagnostics.filter(
        (x) => !this.addedDiagnosticsIds.includes(x.id)
      );
    },
    addedDiagnosticsIds() {
      return this.localSelected.map((x) => x.id);
    },
  },
  async created() {
    await this.getDiagnostics();
    await this.getLastDiagnosis();
  },
  methods: {
    async getLastDiagnosis() {
      const { data } = await getLastDiagnosis(
        this.item.studentSieId,
        this.item.disciplineTypeId
      );

      this.localSelected = data ? data : [];
    },
    async onSave() {
      if (this.addedDiagnosticsIds.length > 0) {
        await saveStudentDiagnosis({
          studentSieId: this.item.studentSieId,
          disciplineTypeId: this.item.disciplineTypeId,
          diagnostics: this.addedDiagnosticsIds,
        });
        this.ShowToast(
          'Proceso Exitoso.',
          'Diagnóstico Guardado Exitosamente',
          'success'
        );
        this.onCancel();
      } else {
        this.ShowToast(
          'Error',
          'Debe seleccionar al menos un diagnóstico.',
          'error'
        );
      }
    },
    onDeleteItemHandler(index) {
      this.localSelected.splice(index, 1);
    },
    onCancel() {
      this.$emit('cancel');
    },
    async getDiagnostics() {
      await getCodeStudentDiagnostics(this.item.disciplineTypeId)
        .then((res) => {
          this.diagnostics = [this.otherSettings.option, ...res.data];
        })
        .catch((err) => {
          this.ShowToast('Error', err.response.data.message, 'error');
        });
    },
    async searchDiagnostics(term = '') {
      const included = this.otherSettings.data
        .map((x) => x.name)
        .includes(term?.trim());
      if (included) return [];
      try {
        const { data } = await searchDiagnosticsExcludingStudent(
          this.item.studentSieId,
          term
        );
        this.otherSettings.data = data;
        return data;
      } catch (error) {
        this.ShowToast('Error', error.response.data.message, 'error');
        this.otherSettings.data = [];
        return [];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.reason-item {
  border-radius: 50px;
  border: 1px solid gainsboro;
  width: fit-content;
  font-size: 90%;
}
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
</style>
